import { Button, Card } from "@repo/ui";

export function Contact() {
  document.title = "ติดต่อเรา — Lucky News";
  return (
    <div className="space-y-6 max-w-xl">
      <h1 className="font-display text-3xl">ติดต่อเรา</h1>
      <Card className="p-6 bg-card/60 grid gap-3">
        <a className="text-primary hover:underline" href="https://line.me/R/ti/p/@luckynews">
          แชทผ่าน LINE
        </a>
        <a className="text-primary hover:underline" href="https://wa.me/0000000000">
          แชทผ่าน WhatsApp
        </a>
        <Button asChild variant="outline">
          <a href="#" onClick={(e) => e.preventDefault()}>
            สนับสนุนเรา
          </a>
        </Button>
        <div className="text-sm text-foreground/70">อีเมล: hello@luckynews.co</div>
      </Card>
    </div>
  );
}

export default Contact;
